
export const clients = [
  {
    name: 'Legendary Motor Cars',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/9e6df3412adda2d95f0a644902d8400b.jpeg',
    industry: 'Automotive',
  },
  {
    name: 'Drake Hotel',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/6bba165c175149448f412e0b5a465dc8.jpeg',
    industry: 'Hospitality',
  },
  {
    name: 'Blue Giant',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/02e7d437603f3d4f33a34900627a2e36.jpeg',
    industry: 'Industrial',
  },
  {
    name: 'Crane Worldwide',
    image: 'https://public.readdy.ai/ai/img_res/1e47b2ba5a803ce83767cc3b8e4daf58.jpg',
    industry: 'Logistics',
  },
  {
    name: 'Subway',
    image: 'https://readdy.ai/api/search-image?query=Subway%20restaurant%20franchise%20corporate%20logo%20green%20yellow%20text%20on%20clean%20white%20background%20brand%20identity%20simple%20minimalist%20design%20high%20resolution&width=300&height=200&seq=client5&orientation=landscape',
    industry: 'Food & Beverage',
  },
  {
    name: 'Cellular Point',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/2047f975488bf4bb29a6eb36a486fd52.jpeg',
    industry: 'Retail',
  },
  {
    name: 'Hellenic Homes for the Aged',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/81919f4bef9936ad71d0604319899626.jpeg',
    industry: 'Healthcare',
  },
  {
    name: 'Value Mobile',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/b95e42886136b018f9cc73705847419f.png',
    industry: 'Retail',
  },
  {
    name: 'Drake Devonshire',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/63d4bbcb4a2dd9c4465d50455f20fdf5.png',
    industry: 'Hospitality',
  },
  {
    name: 'Cargo Cabbie',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/2248d44db3d17800674d55e9c0795114.jpeg',
    industry: 'Logistics',
  },
  {
    name: 'Aramark',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/e3c7d0b317f44310ceb40367326e0199.png',
    industry: 'Food & Beverage',
  },
  {
    name: 'ASUS',
    image: 'https://readdy.ai/api/search-image?query=ASUS%20computer%20technology%20corporate%20logo%20bold%20text%20on%20clean%20white%20background%20brand%20identity%20simple%20minimalist%20design%20high%20resolution&width=300&height=200&seq=client12&orientation=landscape',
    industry: 'Technology',
  },
  {
    name: 'Bulk Barn',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/8132d25968fe644fe51090f332b4195c.png',
    industry: 'Retail',
  },
  {
    name: 'Queensgate Homes',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/5df9838c13500b82f3f41db35bb26c67.png',
    industry: 'Real Estate',
  },
  {
    name: 'Esso',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/62b4690d857f54c9ea33e651269be273.png',
    industry: 'Energy',
  },
  {
    name: 'First National',
    image: 'https://readdy.ai/api/search-image?query=First%20National%20mortgage%20lender%20corporate%20logo%20professional%20text%20on%20clean%20white%20background%20brand%20identity%20simple%20minimalist%20design%20high%20resolution&width=300&height=200&seq=client16&orientation=landscape',
    industry: 'Finance',
  },
  {
    name: 'Glen Rouge Homes',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/1398e60f073aa78cd7f6fe2a31ba6b52.png',
    industry: 'Real Estate',
  },
  {
    name: 'Mississauga Hardware',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/72486fbd0d75e3b14e4848b702f09aa3.jpeg',
    industry: 'Retail',
  },
  {
    name: 'The Humberview Group',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/b9711ad6a158fa60d5e032b0dbee5c96.png',
    industry: 'Automotive',
  },
  {
    name: 'Seacore Seafood',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/b95e42886136b018f9cc73705847419f.png',
    industry: 'Food & Beverage',
  },
  {
    name: 'Coffee Time',
    image: 'https://readdy.ai/api/search-image?query=Coffee%20Time%20cafe%20franchise%20corporate%20logo%20warm%20text%20on%20clean%20white%20background%20brand%20identity%20simple%20minimalist%20design%20high%20resolution&width=300&height=200&seq=client21&orientation=landscape',
    industry: 'Food & Beverage',
  },
  {
    name: 'NCCF',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/c2c704ac8d9b413ed86bec813a835585.jpeg',
    industry: 'Non-Profit',
  },
  {
    name: 'All Crane',
    image: 'https://readdy.ai/api/search-image?query=All%20Crane%20rental%20equipment%20corporate%20logo%20industrial%20text%20on%20clean%20white%20background%20brand%20identity%20simple%20minimalist%20design%20high%20resolution&width=300&height=200&seq=client23&orientation=landscape',
    industry: 'Industrial',
  },
  {
    name: 'Maverick Distillery',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/b79edc79400a27859ee3eb45c3c656ee.png',
    industry: 'Food & Beverage',
  },
  {
    name: 'Essdo',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/5379746381228b5f1ecce8f7df64d64c.jpeg',
    industry: 'Retail',
  },
  {
    name: 'Tim Hortons',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/a3f9260e0ccd0866f43363c524edfe05.png',
    industry: 'Food & Beverage',
  },
  {
    name: 'Shoppers Drug Mart',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/ff8f6ab6add3ac8f147a6768092ebd47.jpeg',
    industry: 'Retail',
  },
  {
    name: 'Canadian Tire',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/e27adcf7cadbbcf092376d8388119615.jpeg',
    industry: 'Retail',
  },
  {
    name: 'Petro-Canada',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/6fd00cda4eae2accbb5b98dca0c1a8c2.png',
    industry: 'Energy',
  },
  {
    name: 'Royal LePage',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/9df6c49ff0bbf5958d438e347e334adb.png',
    industry: 'Real Estate',
  },
  {
    name: 'Marriott Hotels',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/469dff91b229d0995c855e2a80feabff.png',
    industry: 'Hospitality',
  },
  {
    name: 'Goodlife Fitness',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/69ed7aa3db7a11c53f836f7cd5216ede.png',
    industry: 'Fitness',
  },
  {
    name: 'Rexall Pharmacy',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/f258306d621c4527671e4a69c07cba91.png',
    industry: 'Healthcare',
  },
  {
    name: 'Pizza Nova',
    image: 'https://readdy.ai/api/search-image?query=Pizza%20Nova%20restaurant%20franchise%20corporate%20logo%20red%20text%20on%20clean%20white%20background%20brand%20identity%20simple%20minimalist%20design%20high%20resolution&width=300&height=200&seq=client34&orientation=landscape',
    industry: 'Food & Beverage',
  },
  {
    name: 'Cineplex',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/68df4d95451fba1f20542cab9a0c42e9.png',
    industry: 'Entertainment',
  },
  {
    name: 'LCBO',
    image: 'https://static.readdy.ai/image/fff1181c13d1d5fdcfabeab4ada583e3/3a6547bcacca34d1321b942af4e3948a.png',
    industry: 'Retail',
  },
];

export const industries = [
  'All',
  'Automotive',
  'Energy',
  'Entertainment',
  'Finance',
  'Fitness',
  'Food & Beverage',
  'Healthcare',
  'Hospitality',
  'Industrial',
  'Logistics',
  'Non-Profit',
  'Real Estate',
  'Retail',
  'Technology',
];
